import { axiosClient } from "@/lib/axios";
import { PublicRecording, WithPagination } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const fetchRecordingsForDeletionQueue = async ({
  pageSize = 5,
  pageParam = 0,
}): Promise<WithPagination<PublicRecording>> => {
  const offset = pageParam * pageSize;
  const response = await axiosClient.get(`/recordings/deletion-queue`, {
    params: {
      limit: pageSize,
      offset,
    },
  });

  return response.data;
};

const useGetRecordingsForDeletionQueue = (
  {
    pageSize = 5,
    pageParam = 0,
  }: {
    pageSize?: number;
    pageParam?: number;
  },
  options?: Partial<UseQueryOptions<WithPagination<PublicRecording>>>,
) => {
  return useQuery({
    queryKey: ["recordings", "deletion-queue", pageSize, pageParam],
    queryFn: () => fetchRecordingsForDeletionQueue({ pageSize, pageParam }),
    ...options,
  });
};

export { useGetRecordingsForDeletionQueue };
